import React, {useEffect, useState} from 'react';
import Dashboard from '../../layout/Dashboard';
import api from '../../core/api';
import SpecialForm from '../../components/forms/SpecialForm';

const EditSpecial = ({history, match}) => {
  const [special, setSpecial] = useState({});

  const fetchSpecial = async () => {
    try {
      const {data: special} = await api.get(
        `/specials/${match.params.specialId}`,
      );
      setSpecial(special);
    } catch (e) {
      alert(e);
    }
  };

  useEffect(() => {
    fetchSpecial();
  }, []);

  return (
    <Dashboard>
      {special.id && <SpecialForm history={history} special={special} />}
    </Dashboard>
  );
};

export default EditSpecial;
